import { pushStoryInteraction, INTERACTION_TYPE } from '@/helpers/dataLayer';
import { videoId } from '../video-widget/video-model';

const VIDEO_PLAY_THRESHOLD_MS = 10000;

const SOURCES = {
  YOUTUBE: 1,
  VIMEO: 2,
};

export default {
  props: {
    autoPlay: {},
    loop: {},
    mute: {},
    source: {},
    startTime: {},
    videoUrl: {},
    trackingContext: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      playedThresholdTimer: null,
      hasFiredPlay: false,
    };
  },
  computed: {
    classModifiers() {
      return {
        'video-view': true,
      };
    },
    isYoutube() {
      return this.source === SOURCES.YOUTUBE;
    },
    isVimeo() {
      return this.source === SOURCES.VIMEO;
    },
    youtubeVideoId() {
      return videoId(this);
    },
    youtubePlayerVars() {
      return {
        rel: 0,
        start: this.startTime,
        autoplay: this.autoPlay ? 1 : 0,
      };
    },
    playerHeight() {
      return '100%';
    },
    playerWidth() {
      return '100%';
    },
    vimeoVideoId() {
      return videoId(this);
    },
    vimeoPlayerVars() {
      const params = {
        responsive: false,
        muted: this.mute,
        start_time: this.startTime,
      };
      return params;
    },
  },
  methods: {
    youtubeEnded() {
      this.onPaused();
      if (this.loop && this.$refs.youtubePlayer) {
        this.$refs.youtubePlayer.player?.seekTo(this.startTime || 0);
        this.$refs.youtubePlayer.player?.playVideo();
      }
    },
    onPlaying() {
      if (this.hasFiredPlay || this.playedThresholdTimer || !this.trackingContext.storyId) return;
      this.playedThresholdTimer = setTimeout(() => {
        this.hasFiredPlay = true;
        pushStoryInteraction({
          interactionType: INTERACTION_TYPE.VIDEO_PLAY,
          ...this.trackingContext,
        });
      }, VIDEO_PLAY_THRESHOLD_MS);
    },
    onPaused() {
      if (this.playedThresholdTimer) {
        clearTimeout(this.playedThresholdTimer);
        this.playedThresholdTimer = null;
      }
    },
  },
  beforeUnmount() {
    if (this.playedThresholdTimer) {
      clearTimeout(this.playedThresholdTimer);
      this.playedThresholdTimer = null;
    }
  },
};
